import { CmsLink } from 'src/types'
import * as Styles from './LineLink.style'
import { Link } from 'react-router-dom'
import Text from '../Text/Text'

const LineLink: React.VFC<CmsLink> = (props) => {
    return (
        <div>
            <Styles.Wrapper as={Link} to={props.url} target={props.target}>
                <Text textVariant="small2" as="span">
                    {props.title}
                </Text>
            </Styles.Wrapper>
        </div>
    )
}

export default LineLink
